<template>
  <v-text-field
    ref="inputfield"
    :hint="hint"
    :disabled="disabled"
    :persistent-hint="persistentHint"
    :single-line="singleLine"
    :hide-details="hideDetails"
    :dense="dense"
    :rules="rules"
    :height="height"
    :width="width"
    type="number"
    :min="min || min === 0 ? min / factor : undefined"
    :max="max ? max / factor : undefined"
    :step="step ? step / factor : undefined"
    :label="label"
    :title="title"
    :validate-on-blur="validateOnBlur"
    :value="value / factor"
    @change="changeValue"
  >
    <template #append-outer>
      <slot name="append-outer"></slot>
    </template>
  </v-text-field>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

@Component({
  name: 'NumberFieldFactor',
  props: {
    label: String,
    title: String,
    width: String,
    height: String,
    disabled: Boolean,
    positiveOnly: {
      type: Boolean,
      default: false,
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    validateOnBlur: Boolean,
    rules: Array,
    factor: {
      type: Number,
      default: 1,
    },
    round: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    step: {
      type: Number,
    },
  },
})
export default class NumberFieldFactor extends Vue {
  private factor!: number
  private value!: number
  private round!: number
  private singleLine!: boolean
  private hideDetails!: boolean
  private dense!: boolean
  private positiveOnly!: boolean
  private min!: number
  private max!: number
  private step!: number

  changeValue(newV: any) {
    this.$nextTick(() => {
      //@ts-ignore
      if (this.$refs.inputfield && !this.$refs.inputfield.badInput) {
        //@ts-ignore
        let newVal = parseFloat(newV) * this.factor
        if (this.positiveOnly && newVal < 0) {
          newVal = -newVal
          //Hack pour si le symbole '-'  est ajouté au début de la zone de text
          //@ts-ignore
          this.$refs.inputfield.value = 0
          this.$nextTick(() => {
            //@ts-ignore
            this.$refs.inputfield.value = this.round ? Math.round(newVal) : newVal
          })
        }
        if (typeof this.min == 'number' && newVal < this.min) newVal = this.min
        if (typeof this.max == 'number' && newVal > this.max) newVal = this.max
        if (this.value == newVal) {
          //@ts-ignore
          this.$refs.inputfield.lazyValue = this.round ? Math.round(newVal) : newVal
        }
        this.$emit('input', this.round ? Math.round(newVal) : newVal)
      }
    })
  }
}
</script>
